import {enrichUserAlertsWithVehicleNames, getMakesWithModelsOptions} from './utils.js'

const getInitialProps = async ({routeInfo, context: {i18n, domain}}) => {
  const config = domain.get('config')

  const {FILTER_NAMES} = config.get('searchFilters')

  const {pageName} = await domain.get('get_page_name_page_use_case').execute({path: routeInfo.location.pathname})

  const getUserAlerts = () => domain.get('get_user_alerts_use_case').execute()

  const getPageTrackingData = () =>
    domain.get('get_page_tracking_data_use_case').execute({
      page: pageName
    })

  const getSeoData = () => domain.get('get_seo_data_use_case').execute({culture: i18n.culture, pageName})

  const getMakesWithModels = () => domain.get('get_makes_with_models_vehicles_use_case').execute()

  const [
    {
      value: [userAlertsError, userAlertsResponse]
    },
    {value: pageTrackingData},
    {
      value: [seoDataError, {head: helmet} = {}]
    },
    {
      value: [, makesWithModels]
    }
  ] = await Promise.allSettled([getUserAlerts(), getPageTrackingData(), getSeoData(), getMakesWithModels()])

  const enrichedUserAlerts = enrichUserAlertsWithVehicleNames(
    userAlertsResponse?.userAlerts || [],
    makesWithModels?.value
  )

  return {
    helmet,
    listFiltersOptions: {
      [FILTER_NAMES.VEHICLES]: {
        options: getMakesWithModelsOptions({makesWithModels: makesWithModels?.value})
      }
    },
    pageName,
    pageTrackingData,
    seoDataError,
    userAlerts: enrichedUserAlerts,
    userAlertsError
  }
}

export default getInitialProps
